export const SHARE_FREE_CONTENT_FLOW_NAME = 'ShareFreeContent';
